import { Injectable, Optional } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Subscribable } from '../../components/base-component/subscribable';

@Injectable()
export class NgSwLogUpdateService extends Subscribable {
  constructor(@Optional() private readonly updates: SwUpdate) {
    super();
  }

  init() {
    if (this.updates) {
      this.subscribe(this.updates.available, (event) => {
        console.log('current version is', event.current);
        console.log('available version is', event.available);
      });
      this.subscribe(this.updates.activated, (event) => {
        console.log('old version was', event.previous);
        console.log('new version is', event.current);
      });
    }
  }
}
